import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import * as S3 from "aws-sdk/clients/s3";
import { X } from "@angular/cdk/keycodes";
import { WebApiService } from "./web-api.service";
import { KycTokenAuthService } from "./kyc-token-auth.service";

// 2026-10-26 (release hardening): POST /s3Operations/getPreSignedUrl needs a session. Signed-in pages send it as the
// usual id/hash headers; the token pages (KYC link, PO / RFQ / service PO / service RFQ links) have no login, so the
// link tokens the web keeps in sessionStorage and the KYC token go in the body, exactly as PrivateFileService does for
// signed reads. The API verifies them and only signs keys in that token's own folder.
const LINK_TOKEN_KEYS = ["poAccessToken", "rfqAccessToken", "servicePoAccessToken", "serviceRfqAccessToken"];

@Injectable({
  providedIn: "root",
})
export class AwsSdkService {
  /** Set credentials of appropriate aws account to
   * pass into S3 bucket service. */
  // private s3Bucket = new S3({
  //   accessKeyId: environment.accessKeyId,
  //   secretAccessKey: environment.secretAccessKey,
  //   region: environment.region,
  // });

  constructor(private webApiService: WebApiService, private kycTokenAuth: KycTokenAuthService) {}

  /**
   * Uploads an arbitrarily sized buffer, blob, or stream to S3 bucket.
   * @param _s3Params A request configuration object.
   */
  // public uploadObject(
  //   _s3Params: S3.PutObjectRequest
  // ): Promise<S3.ManagedUpload.SendData> {
  //   _s3Params.Bucket = environment.bucketName;
  //   return this.s3Bucket.upload(_s3Params).promise();
  // }
  public uploadObject(
    FormData: any
  ): Promise<any> {
    let apiUrl = "/s3Operations/uploadObject";
    console.log("FormData",FormData.get('file'));
    return this.webApiService.postRequest<any>(apiUrl, FormData);
  }

  // public downloadObject(
  //   _s3Params: S3.GetObjectRequest
  // ): Promise<S3.GetObjectOutput> {
  //   return this.s3Bucket.getObject(_s3Params).promise();
  // }
  public downloadObject(
    _s3Params: S3.GetObjectRequest
  ): Promise<any> {
    let apiUrl = "/s3Operations/downloadObject";
    return this.webApiService.postRequest<any>(apiUrl, _s3Params);
  }

  // public downloadObjectWithoutError(
  //   _s3Params: S3.GetObjectRequest
  // ): Promise<S3.GetObjectOutput> {
  //   try {
  //     return this.s3Bucket.getObject(_s3Params).promise();
  //   }
  //   catch(e) {
  //     console.log("Key Doesn't exists");
  //   }
  // }

  public getSignedUrlPromise(
    _s3Params: any,
    httpOptions: any = {}
  ): Promise<any> {
    let apiUrl = "/s3Operations/getPreSignedUrl";
    const body: any = { ...(_s3Params || {}) };
    const linkTokens = LINK_TOKEN_KEYS.map((k) => { try { return sessionStorage.getItem(k); } catch { return null; } })
      .filter((t): t is string => !!t);
    if (linkTokens.length) body.linkTokens = linkTokens;
    const kycToken = this.kycTokenAuth.getToken();
    if (kycToken) body.kycToken = kycToken;
    return this.webApiService.postRequest<any>(apiUrl, body, httpOptions);
  }

  public copyObject(
    _s3Params: S3.CopyObjectRequest
  ): Promise<any> {
    let apiUrl = "/s3Operations/copyObject";
    return this.webApiService.postRequest<any>(apiUrl, _s3Params);
  }

  public extractS3LocationFromUrl(s3PreSignedUrl: string): string {
    // Find the index of the first occurrence of '?' character
    const questionMarkIndex = s3PreSignedUrl.indexOf('?');
    
    // If '?' character is found, extract the URL part before it
    if (questionMarkIndex !== -1) {
        return s3PreSignedUrl.substring(0, questionMarkIndex);
    } else {
        // If '?' character is not found, return the original URL
        return s3PreSignedUrl;
    }
  } 
}
